<template>
  <v-dialog v-model="active" width="800" persistent="">
    <v-card>
      <v-card-title class="headline" primary-title>Editar Producto</v-card-title>

      <v-card-text>
        <v-text-field label="Titulo" v-model="item_product.title"></v-text-field>
        <v-textarea
          auto-grow
          rows="1"
          row-height="10"
          label="Descripción"
          v-model="item_product.description"
        ></v-textarea>

        <v-sheet class="mx-auto" max-width="700">
          <v-slide-group multiple show-arrows v-model="images_delete">
            <v-slide-item v-for="n in images" :key="n+'tt'" v-slot:default="{ active, toggle }">
              <v-card 
                class="ma-4" 
                :input-value="active" 
                height="100" 
                width="180" 
                @click="toggle" 
                :color="active ? 'primary' : ''">
                  <v-icon
                    v-if="active"
                    color="white"
                    size="48"
                    v-text="'mdi-close-circle-outline'"
                    class="text-center"
                  ></v-icon>
                  <v-img
                    v-if="!active"
                    contain
                    class="white--text align-end"
                    aspect-ratio="2"
                    :src="n"
                    :lazy-src="n"
                  ></v-img>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>

        <v-file-input multiple label="Cargar Imagenes" v-model="productImage"></v-file-input>
      </v-card-text>
      <!-- {{item_product.pictures}} -->

      <!-- <v-divider></v-divider> -->

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="loading" @click="update_product(item_product)">Aceptar</v-btn>
        <v-btn color="#b2aaaa" dark @click="$emit('dialog:change', 'cerrar')">Cancelar</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["active", "item_product", "images"],
  data() {
    return {
      loading: false,
      productImage: [],
      images_delete: []
    };
  },

  // created() {
  //   this.productImage = JSON.parse(this.item_product.pictures);
  // },

  methods: {
    async update_product(item_product) {
      try {
        this.loading = true;
        const detele_pictures = item_product.pictures.reduce((accumulator, currentValue, index) => {
          this.images_delete.includes(index) && accumulator.push(currentValue) 
          return accumulator
        },[])

        console.log('detele_pictures',detele_pictures)
        console.log('item_product.pictures',item_product.pictures)
       

        let formData = new FormData();
        formData.append("title", item_product.title);
        formData.append("post_ml", item_product.item_id);
        formData.append("description", item_product.description);
        
        for (const fileObject of this.productImage) {
            formData.append('pictures[]', fileObject);
        }

        for (const fileObjectImage of detele_pictures) {
            formData.append('detele_pictures[]', fileObjectImage);
        }

        const request = {
            formData: formData
        }

        const response = await this.$store.dispatch(
          "categories/UPDATE_PRODUCT",
          request
        );
        console.log(response);

        this.loading = false;

        Swal.fire({
          title: "Actualizado !",
          text: "Tu producto ha sido actualizado con éxito.",
          icon: "success",
          confirmButtonColor: "#7160ec"
        });

        this.$emit('dialog:change', 'cerrar')
      } catch (e) {
        console.log("status", e.response.data.status);
        if (e.response.data.status == 400) {
          Swal.fire({
            title: "Actualizacion fallida",
            text:
              "No se lograron actualizar los datos de sus productos, por favor intente mas tarde.",
            icon: "error",
            showCancelButton: true,
            confirmButtonColor: "#7160ec",
            cancelButtonColor: "#b2aaaa",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar"
          });
        } else {
          Swal.fire({
            title: "Lo sentimos",
            text: "consulte al administrador.",
            icon: "error",
            showCancelButton: true,
            confirmButtonColor: "#7160ec",
            cancelButtonColor: "#b2aaaa",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar"
          });
        }

        this.loading = false;

        console.log(e);
      }
    }
  }
};
</script>

<style>
</style>